<template>
  <div v-if="modelValue !== null">
    <div class="policy-payment-info row">
      <div class="columns">
        <LabelAndTooltip :label="modelValue.Label" :tooltip="modelValue.Tooltip" />
      </div>
      <div class="columns">
        <div
          v-for="(payment, i) in modelValue.Payments"
          :key="'payment' + i"
          data-policy-payment-information-details
        >
          <div v-if="!payment.AmountFormatted">
            <p data-policy-details-payment-date v-html="payment.DateFormatted" />
          </div>
          <div v-else data-policy-payment-information-full>
            <div
              v-if="payment.IsLatePaymentFee"
              class="policy-details-payment-lines"
              data-policy-details-late-fee-label
              v-html="modelValue.SubPaymentLabel"
            />
            <div
              v-else
              class="policy-details-payment-lines"
              data-policy-details-payment-date
              v-html="payment.DateFormatted"
            />

            <div data-policy-details-payment-info class="policy-details-payment-lines">
              <span data-policy-details-payment-amount v-html="payment.AmountFormatted" />
              <span
                v-if="payment.Disclaimer"
                data-policy-details-payment-disclaimer
                class="policy-detail-view-price-disclaimer show-for-large"
                v-html="payment.Disclaimer"
              />
              <div
                v-if="payment.Disclaimer"
                class="hide-for-large"
                data-policy-details-payment-disclaimer
                v-html="payment.Disclaimer"
              />
            </div>
            <div
              v-if="payment.AdditionalStatusText"
              class="policy-details-payment-lines"
              data-policy-additional-status-text
              v-html="payment.AdditionalStatusText"
            />
            <div
              v-if="payment.SubPayment"
              class="policy-details-payment-lines"
              data-test-policy-sub-payment
            >
              <div>
                <span
                  data-test-policy-sub-payment-amount
                  v-html="payment.SubPayment.AmountFormatted"
                />
                <span
                  data-test-policy-sub-payment-disclaimer
                  class="policy-detail-view-price-disclaimer show-for-large"
                  v-html="payment.SubPayment.Disclaimer"
                />
              </div>
              <div
                data-test-sub-payment-disclaimer
                class="hide-for-large"
                v-html="payment.SubPayment.Disclaimer"
              />
              <div
                v-if="payment.SubPayment.AdditionalStatusText"
                data-test-sub-payment-additional-status-text
                v-html="payment.SubPayment.AdditionalStatusText"
              />
            </div>
            <p v-if="payment.HasGeneratedBill">
              <a
                data-policy-details-payment-bill
                :href="payment.GeneratedBill.BillUrl"
                v-html="payment.GeneratedBill.BillText"
              />
            </p>
            <p v-if="payment.StatusText">
              <span
                v-if="payment.HasBeenPaid"
                class="payment-status icon-circle-check show-for-large"
                data-test-payment-status-icon
              />
              <span
                data-test-payment-status
                :class="{ 'payment-status-text': payment.HasBeenPaid }"
                v-html="payment.StatusText"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LabelAndTooltip from '@/components/UI/LabelAndTooltip.vue';

export default {
  components: {
    LabelAndTooltip
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  created() {}
};
</script>
